(function () {
  'use strict';

  function initHorizontalCardScroll(sectionId, options) {
    const itemSelector = options.itemSelector;
    const container = document.getElementById(options.containerId);
    const scrollWrapper = document.getElementById(options.scrollWrapperId);
    if (!container) return;

    if (container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';

    const scrollbarWrapper = document.getElementById(options.scrollbarWrapperId);
    const scrollbarTrack = document.getElementById(options.scrollbarTrackId);
    const scrollbarThumb = document.getElementById(options.scrollbarThumbId);
    const grabbingClass = options.grabbingClass || 'is-grabbing';

    function getScrollContainer() {
      return scrollWrapper || container;
    }

    function getContainerVisibleWidth(scrollContainer) {
      return scrollContainer ? scrollContainer.clientWidth : 0;
    }

    function getContentScrollWidth() {
      const scrollContainer = getScrollContainer();
      return scrollContainer ? scrollContainer.scrollWidth : 0;
    }

    let cachedItems = null;
    let cachedItemCount = 0;
    let cachedIsMobileView = window.innerWidth <= 768;
    let cachedTrackWidth = cachedIsMobileView ? 64 : 160;
    let cachedThumbWidth = cachedIsMobileView ? 32 : 66;
    let rafId = null;
    let lastUpdateTime = 0;
    const UPDATE_THROTTLE = 16;

    function updateCache() {
      cachedItems = container.querySelectorAll(itemSelector);
      cachedItemCount = cachedItems.length;
      const newIsMobileView = window.innerWidth <= 768;
      if (newIsMobileView !== cachedIsMobileView) {
        cachedIsMobileView = newIsMobileView;
        cachedTrackWidth = cachedIsMobileView ? 64 : 160;
        cachedThumbWidth = cachedIsMobileView ? 32 : 66;
      }
    }

    function updateCustomScrollbar(forceLayout) {
      if (!scrollbarWrapper || !scrollbarTrack || !scrollbarThumb) return;

      updateCache();

      if (cachedItemCount <= 1) {
        scrollbarWrapper.style.display = 'none';
        return;
      }

      const scrollContainer = getScrollContainer();

      if (forceLayout) {
        if (scrollContainer) {
          scrollContainer.offsetHeight;
          scrollContainer.scrollWidth;
        }
        container.offsetHeight;
        container.offsetWidth;
        container.scrollWidth;
      }

      const containerWidth = getContainerVisibleWidth(scrollContainer);
      const scrollWidth = getContentScrollWidth();
      const scrollLeft = scrollContainer ? scrollContainer.scrollLeft : 0;
      const maxScroll = Math.max(0, scrollWidth - containerWidth);

      if (maxScroll <= 1 || scrollWidth <= containerWidth) {
        scrollbarWrapper.style.display = 'none';
        return;
      }

      scrollbarWrapper.style.display = 'block';
      scrollbarWrapper.style.width = cachedIsMobileView ? '64px' : '160px';
      scrollbarThumb.style.width = cachedThumbWidth + 'px';

      const maxThumbLeft = Math.max(0, cachedTrackWidth - cachedThumbWidth);
      const clampedScrollLeft = Math.max(0, Math.min(scrollLeft, Math.max(0, maxScroll - 0.1)));

      let thumbLeft = 0;
      if (maxScroll > 0.1) {
        thumbLeft = (clampedScrollLeft / maxScroll) * maxThumbLeft;
      }

      thumbLeft = Math.max(0, Math.min(thumbLeft, Math.max(0, maxThumbLeft - 0.01)));
      scrollbarThumb.style.left = thumbLeft + 'px';
    }

    function throttledUpdateCustomScrollbar() {
      const now = performance.now();
      if (now - lastUpdateTime < UPDATE_THROTTLE) {
        if (rafId) return;
        rafId = requestAnimationFrame(function () {
          rafId = null;
          lastUpdateTime = performance.now();
          updateCustomScrollbar(false);
        });
        return;
      }
      lastUpdateTime = now;
      updateCustomScrollbar(false);
    }

    function setupMouseDragScroll() {
      const scrollContainer = getScrollContainer();
      if (!scrollContainer) return;

      let mousedown = false;
      let startX = 0;
      let scrollPos = 0;
      let sliderStart = 0;

      function getSliderStart() {
        return scrollContainer.getBoundingClientRect().left;
      }

      function handleMousedown(e) {
        if (e.button !== 0) return;
        mousedown = true;
        sliderStart = getSliderStart();
        startX = e.pageX - sliderStart;
        scrollPos = scrollContainer.scrollLeft;
        scrollContainer.classList.add(grabbingClass);
        scrollContainer.style.cursor = 'grabbing';
        scrollContainer.style.userSelect = 'none';
      }

      function handleMouseup() {
        mousedown = false;
        scrollContainer.classList.remove(grabbingClass);
        scrollContainer.style.cursor = '';
        scrollContainer.style.userSelect = '';
      }

      function handleMousemove(e) {
        if (!mousedown) return;
        e.preventDefault();
        const x = e.pageX - sliderStart;
        scrollContainer.scrollLeft = scrollPos - (x - startX) * 12;
      }

      if (!scrollContainer._mouseDragBound) {
        scrollContainer.addEventListener('mousedown', handleMousedown);
        document.addEventListener('mouseup', handleMouseup);
        document.addEventListener('mouseleave', handleMouseup);
        document.addEventListener('mousemove', handleMousemove);
        scrollContainer._mouseDragBound = true;
      }
    }

    function initScrollBehavior() {
      const scrollContainer = getScrollContainer();
      if (!scrollContainer) return;

      scrollContainer.offsetHeight;
      container.offsetHeight;

      updateCache();
      const containerWidth = getContainerVisibleWidth(scrollContainer);
      const scrollWidth = getContentScrollWidth();
      const needsScroll = cachedItemCount > 1 && scrollWidth > containerWidth;

      if (needsScroll) {
        updateCustomScrollbar(true);

        if (!scrollContainer._scrollHandler) {
          scrollContainer._scrollHandler = throttledUpdateCustomScrollbar;
          scrollContainer.addEventListener('scroll', scrollContainer._scrollHandler, { passive: true });
        }

        if (window.matchMedia('(pointer: fine)').matches) {
          setupMouseDragScroll();
        }

        if (!scrollContainer._wheelHandler) {
          let cachedRect = null;
          let rectCacheTime = 0;

          scrollContainer._wheelHandler = function (e) {
            const now = performance.now();
            if (!cachedRect || now - rectCacheTime > 100) {
              cachedRect = scrollContainer.getBoundingClientRect();
              rectCacheTime = now;
            }

            const isInside =
              e.clientX >= cachedRect.left &&
              e.clientX <= cachedRect.right &&
              e.clientY >= cachedRect.top &&
              e.clientY <= cachedRect.bottom;

            if (!isInside) return;

            if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) {
              const visibleWidth = getContainerVisibleWidth(scrollContainer);
              const contentWidth = getContentScrollWidth();
              const maxScroll = Math.max(0, contentWidth - visibleWidth);
              const scrollLeft = scrollContainer.scrollLeft;
              const deltaY = e.deltaY;
              const atStart = scrollLeft <= 0;
              const atEnd = scrollLeft >= maxScroll - 1;

              if ((deltaY > 0 && atEnd) || (deltaY < 0 && atStart)) {
                return;
              }

              e.preventDefault();

              let newScrollLeft = scrollLeft + deltaY * 12;
              newScrollLeft = Math.max(0, Math.min(newScrollLeft, maxScroll));

              scrollContainer.scrollLeft = newScrollLeft;
              throttledUpdateCustomScrollbar();
            }
          };
          scrollContainer.addEventListener('wheel', scrollContainer._wheelHandler, { passive: false });
        }

        if (!container._resizeScrollbarHandler) {
          let resizeTimer = null;
          container._resizeScrollbarHandler = function () {
            if (resizeTimer) clearTimeout(resizeTimer);
            updateCache();
            resizeTimer = setTimeout(function () {
              const activeScrollContainer = getScrollContainer();
              if (!activeScrollContainer) return;

              container.offsetHeight;
              activeScrollContainer.offsetHeight;

              const visibleWidth = getContainerVisibleWidth(activeScrollContainer);
              const contentWidth = getContentScrollWidth();
              updateCache();

              if (cachedItemCount > 1 && contentWidth > visibleWidth) {
                updateCustomScrollbar(true);
                setTimeout(function () {
                  updateCustomScrollbar(true);
                }, 200);
              } else if (scrollbarWrapper) {
                scrollbarWrapper.style.display = 'none';
              }
            }, 150);
          };
          window.addEventListener('resize', container._resizeScrollbarHandler, { passive: true });
        }
      } else if (scrollbarWrapper) {
        scrollbarWrapper.style.display = 'none';
      }
    }

    function init() {
      updateCache();
      initScrollBehavior();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          updateCustomScrollbar(true);
          setTimeout(function () {
            updateCustomScrollbar(true);
          }, 300);
        });
      });
    }

    init();

    const images = container.querySelectorAll('img');
    let loadedCount = 0;
    const totalImages = images.length;

    if (totalImages === 0) {
      requestAnimationFrame(function () {
        updateCustomScrollbar(true);
      });
      return;
    }

    function checkAndUpdate() {
      if (loadedCount === totalImages) {
        requestAnimationFrame(function () {
          updateCustomScrollbar(true);
        });
      }
    }

    images.forEach(function (img) {
      if (img.complete) {
        loadedCount++;
      } else {
        img.addEventListener(
          'load',
          function () {
            loadedCount++;
            checkAndUpdate();
          },
          { once: true }
        );
      }
    });
    checkAndUpdate();
  }

  window.initHorizontalCardScroll = initHorizontalCardScroll;
})();
